/** @format */

/**
 * This module intentionally imports nothing so it stays free of any `msw` dependency and is
 * safe to import from production-reachable code.
 */
type PrepareApp = () => Promise<void>;

/**
 * No-op preparation hook for production-like environments.
 */
export const noopPrepareApp: PrepareApp = async () => {
  // Intentionally empty: production-like builds must not start Mock Service Worker.
};
